module.exports = __webpack_public_path__ + "static/img/human-1.eb4aab9b.png";